import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearSngResult } from '../redux/gameSlice';
import './KickedNotice.css';

const ordinal = (n) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

// Global popup shown when this player's Sit-and-Go run ends (bust, leave while running,
// or outright win — SNG_RESULT). Reuses the kicked-notice styling; rendered at the app
// level so it survives the table teardown / return to the lobby.
const SngResultNotice = () => {
    const dispatch = useDispatch();
    const result = useSelector((state) => state.games.sngResult);

    if (!result) return null;

    const won = result.place === 1;
    const paid = result.payout > 0;

    return (
        <div className="kicked-notice-overlay" onClick={() => dispatch(clearSngResult())}>
            <div className="kicked-notice-box" onClick={(e) => e.stopPropagation()}>
                <span className="kicked-notice-title">
                    {won ? 'You won the Sit-and-Go!' : `You finished ${ordinal(result.place)}`}
                </span>
                <span className="kicked-notice-subtext">
                    {paid
                        ? `${result.gameName} — ${result.payout} chips added to your balance.`
                        : `${result.gameName} — out of the money this time.`}
                </span>
                <button className="kicked-notice-btn" onClick={() => dispatch(clearSngResult())}>
                    OK
                </button>
            </div>
        </div>
    );
};

export default SngResultNotice;
